/* istanbul ignore file */
const styles = ({ spacing: { unit }, typography: { subtitle } }) => ({
  heading: {
    display: 'flex',
    padding: '0',
    fontWeight: subtitle.fontWeight,
    fontSize: subtitle.fontSize,
    margin: '0 !important'
  },
  left: {
    alignItems: 'center'
  },
  button: {
    marginLeft: unit * 3,
    alignItems: 'center'
  },
  addMapLink: {
    marginLeft: 0
  },
  subHeading: {
    alignItems: 'center',
    display: 'flex'
  },
  modalHeader: {
    marginBottom: 22,
    fontSize: 20
  },
  modalBody: {
    marginBottom: 48
  }
});

export default styles;
